import { API_URL } from "../../url/api";
import { DoctorType } from "./types";

export interface Availability {
  id: number;
  date: string;
  slots: SlotProps[];
}

export interface SlotProps {
  id: number;
  datetime: string;
}

export interface DateProps{
  date: string;
}

export interface DoctorsAvailability {
  id: number;
  name: string;
  description: string;
  age: string;
  image: string;
  user: number;
  availability: Availability[];
}

async function fetchAvailabiltyData(): Promise<DoctorType[]> {
  const url = API_URL + "v2/doctors/";
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

export { fetchAvailabiltyData };
